import commonClass from "./commonClass";

export default class commonGridClass extends commonClass {
  constructor() {
    super();
  }

  /**
   * テキストの生成
   * @param {*} txt
   */
  _genCellText(txt) {
    // 申請中はテキストを赤にする
    if (txt.indexOf('申請中:') === 0) {
      return `<span class="c-grid_txt" style="color: red;">${txt.split('申請中:')[1]}</span>`;
    }
    return `<span class="c-grid_txt">${txt}</span>`
  }

  /**
   * チェックボックスの生成
   * @param {*} isChecked
   * @param {*} txt
   */
  _genCellCheckBox(isChecked, txt = '', cls = '', editable = '') {
    if (editable === false) {
      return txt || (isChecked ? '●' : '');
    }
    return `<div class="c-grid_check"><input class="js-lst-ch" type="checkbox" ${(isChecked) ? 'checked' : ''} ${(editable === false) ? 'disabled' : ''}><span></span></div><span class="${cls}">${txt}</span>`;
  }

  /**
   * セレクトボックスの生成
   */
  _genCellSelectBox(txtArr, txtSelected, recid, field, editable) {

    const options = '<option value="0">------</option>' + txtArr.map(txt => `<option value="${txt.value}" ${(txt.value + '' === txtSelected + '') ? 'selected' : ''}>${txt.text}</option>`);
    return `<div class="c-grid_select"><select data-recid="${recid}" data-field="${field}" ${(editable === false) ? 'disabled' : ''}>${options}</select></div>`;
  }

  /**
  * 未選択無しのセレクトボックスの生成
  */
  _genCellFullSelectBox(txtArr, txtSelected, recid, field) {
    var options = txtArr.map(function (txt) {
        return '<option value="' + txt.value + '" ' + (txt.value + '' === txtSelected + '' ? 'selected' : '') + '>' + txt.text + '</option>';
    });
    return '<div class="c-grid_select"><select data-recid="' + recid + '" data-field="' + field + '">' + options + '</select></div>';
  }

  /**
   * ヘッダーエリアの生成
   * @param {*} caption
   * @param {*} groupLabel
   */
  _genHeaderArea(caption, groupColor = null) {
    const labelArea = `<div class="head__wrapper__top" style="background-color: ${groupColor};"></div>`;
    const captionArea = `<div class="head__wrapper__col">${caption}</div>`;
    return `<div class="head__wrapper">${labelArea}${captionArea}</div>`;
  }

  /**
   * 入力により、チェックボックス/テキストを生成
   * 入力値がbooleanの時はチェックボックスを生成します
   */
  _genCellCheckOrTxt(txt, editable) {
    switch (txt) {
      case '':
        return;
      case true:
        return this._genCellCheckBox(true, undefined, undefined, editable);
      case false:
        return this._genCellCheckBox(false, undefined, undefined, editable);
      default:
        return this._genCellText(txt);
    }
  }

}